import { render } from "./SearchSelect.vue?vue&type=template&id=072ff24b&scoped=true"
import script from "./SearchSelect.vue?vue&type=script&lang=js"
export * from "./SearchSelect.vue?vue&type=script&lang=js"

import "./SearchSelect.vue?vue&type=style&index=0&id=072ff24b&lang=scss&scoped=true"

import exportComponent from "/build/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-072ff24b"]])

export default __exports__